import { useEffect, useState } from "react";
import "../../styles/driver_modal.css";
import { resolveMedia, resolveMediaLicence } from "../../services/api";
import defaultAvatar from "../../assets/logo/logo.png";

export default function DriverEditModal({ open, driver, onClose, onSubmit }) {
  const [form, setForm] = useState({
    user_firstName: "",
    user_lastName: "",
    contact_tel: "",
    contact_email: "",
    contact_whatsapp: "",
    contact_adress: "",

    user_profilPicture: null,
    licenceFront: null,
    licenceBack: null,
  });

  
  useEffect(() => {
    if (!driver) return;

    setForm({
      user_firstName: driver.user?.firstName || "",
      user_lastName: driver.user?.lastName || "",
      contact_tel: driver.user?.contact?.tel || "",
      orderPercentage : driver?.orderPercentage || "",
      contact_email: driver.user?.contact?.email || "",
      contact_whatsapp: driver.user?.contact?.whatsapp || "",
      contact_adress: driver.user?.contact?.adress || "",
      user_profilPicture: null,
      licenceFront: null,
      licenceBack: null,
    });
  }, [driver]);

  useEffect(() => {
    if (open) document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "auto");
  }, [open]);

  if (!open || !driver) return null;

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  function handleFileChange(e) {
    setForm({ ...form, [e.target.name]: e.target.files[0] });
  }

  function handleSubmit(e) {
    e.preventDefault();

    const data = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      if (value !== null && value !== "") {
        data.append(key, value);
      }
    });

    onSubmit(driver.id, data);
  }

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div className="modalCard" onClick={(e) => e.stopPropagation()}>
        <h3>Modifier le chauffeur</h3>

        <form onSubmit={handleSubmit} className="modalForm">

          {/* INFOS GÉNÉRALES */}
          <div className="modalSection">
            <div className="formGrid">
              <Input
                label="Prénom"
                name="user_firstName"
                value={form.user_firstName}
                onChange={handleChange}
                required
              />
             
              <Input
                label="Nom"
                name="user_lastName"
                value={form.user_lastName}
                onChange={handleChange}
                required
              />

              <Input
                label="Téléphone"
                name="contact_tel"
                value={form.contact_tel}
                onChange={handleChange}
                required
              />
              
               <Input
                label="Pourcentage"
                name="orderPercentage"
                value={form.orderPercentage}
                onChange={handleChange}
              />
              
              <Input
                label="Email"
                type="email"
                name="contact_email"
                value={form.contact_email}
                onChange={handleChange}
              />

              <Input
                label="WhatsApp"
                name="contact_whatsapp"
                value={form.contact_whatsapp}
                onChange={handleChange}
              />
              {/* <Input
                label="Adresse"
                name="contact_adress"
                value={form.contact_adress}
                onChange={handleChange}
              /> */}
            </div>
          </div>

          {/* DOCUMENTS*/}
          {/* <div className="modalSection">
            <div className="formGrid">
              <FileInput
                label="Photo de profil"
                name="user_profilPicture"
                onChange={handleFileChange}
                existing={resolveMedia(
                  driver.user?.profilPicture,
                  defaultAvatar
                )}
              />
              <FileInput
                label="Permis (Recto)"
                name="licenceFront"
                onChange={handleFileChange}
                existing={resolveMediaLicence(driver.licenceFront)}
              />
              <FileInput
                label="Permis (Verso)"
                name="licenceBack"
                onChange={handleFileChange}
                existing={resolveMediaLicence(driver.licenceBack)}
              />
            </div>
          </div> */}

          <div className="modalActions">
            <button type="button" className="btnGhost" onClick={onClose}>
              Annuler
            </button>
            <button className="btnPrimary">Enregistrer</button>
          </div>
        </form>
      </div>
    </div>
  );
}

/* ---------- COMPONENTS ---------- */

function Input({ label, ...props }) {
  return (
    <div className="formGroup">
      <label>{label}</label>
      <input {...props} />
    </div>
  );
}

function FileInput({ label, name, onChange, existing }) {
  const [preview, setPreview] = useState(existing || null);

  function handleFile(e) {
    const file = e.target.files[0];
    if (file) {
      setPreview(URL.createObjectURL(file));
      onChange(e);
    }
  }

  return (
    <div className="fileUpload">
      <label className="fileLabel">{label}</label>

      <label className="fileDrop">
        {preview ? (
          <img src={preview} alt="preview" className="filePreview" />
        ) : (
          <div className="filePlaceholder">
            <span className="fileIcon">📷</span>
            <span>Cliquer pour modifier</span>
            <small>PNG, JPG</small>
          </div>
        )}

        <input
          type="file"
          name={name}
          accept="image/*"
          onChange={handleFile}
          hidden
        />
      </label>
    </div>
  );
}
